var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mouse",staticClass:"mouse-container"},[_c('div',{staticClass:"icon"},[_c('div',{staticClass:"icon-inner"},[_c('awesome-icon',{attrs:{"icon":"mouse"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }